import React from 'react';
import classes from "./Logo.css";
import MenuButton from './MenuButton/MenuButton';
import LogoImage from "../../../assets/logo.png";

const Logo = (props) => {
    let customStyle = {};
    if (props.style) {
        customStyle = props.style;
    }
    return (<div className={classes.Logo} style={{ ...customStyle }}>
        <MenuButton />

        <a href="#"><img src={LogoImage} className={classes.logoimage} alt="Youtube Home" /></a>
        <span className={classes.countrySign}>AE</span>
    </div>);
}

export default Logo;